import type { IconProps } from '../types/IconProps.ts';
export const ReceiptText: IconProps = {
    name: 'ReceiptText',
    children: [
        `<path d="M4 2.72a.5.5 0 0 1 .68-.47l1.77.67q.22.07.42-.03l1.33-.75a.5.5 0 0 1 .49 0l1.29.72a.5.5 0 0 0 .49 0l1.28-.72a.5.5 0 0 1 .5 0l1.28.72a.5.5 0 0 0 .5 0l1.28-.72a.5.5 0 0 1 .5 0l1.32.75a.5.5 0 0 0 .42.03l1.77-.67a.5.5 0 0 1 .68.47V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM8 9h5M8 17h5M8 13h8" />`,
    ]
};